import { render, staticRenderFns } from "./Podat.vue?vue&type=template&id=1a4b6fd0&scoped=true&"
import script from "./Podat.vue?vue&type=script&lang=js&"
export * from "./Podat.vue?vue&type=script&lang=js&"
import style0 from "./Podat.vue?vue&type=style&index=0&id=1a4b6fd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4b6fd0",
  null
  
)

export default component.exports